export default "__VITE_ASSET__Di3uKLo3__"